import { isEmpty, map } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { CmsInsuranceTypeContent } from '../../../types';
import { CONTENT_SECTIONS } from '../../../content/sections';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';

type Props = {
  cmsSectionContent: CmsInsuranceTypeContent['addOns'];
};

const mapAddOnsContent = ({ cmsSectionContent }: Props) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const { descriptionRaw, name, productOptions } = cmsSectionContent;

  const formattedContent = {
    description: portableTextToPlain(descriptionRaw),
    tiles: map(
      (option) => ({
        image: getImageAttributes({ imageObject: option.imageObject }),
        summary: portableTextToPlain(option.descriptionRaw),
        title: option.name,
      }),
      productOptions,
    ),
    title: name,
  };

  return {
    content: formattedContent,
    type: CONTENT_SECTIONS.ADD_ONS,
  };
};

export default mapAddOnsContent;
